import React from 'react';

const AnimatedSponsor = ({ sponsors, text, weight, target }) => (
  <>
    {sponsors[target] ? (
      <div className="sponsored-catch" data-testid="sponsor">
        <div className="sponsored-catch__logo">
          <img data-testid="sponsor-logo" src={sponsors[target].imageUrl} style={{ width: '300px', maxWidth: '100%', height: 'auto' }} />
        </div>
        {sponsors[target].tagline ? (
          <div className="sponsored-catch__tagline" style={sponsors[target].bgColor ? { backgroundColor: sponsors[target].bgColor } : {}}>
            <span className="sponsored-catch__tagline-text" style={sponsors[target].textColor ? { color: sponsors[target].textColor } : {}}>
              {sponsors[target].tagline}
            </span>
          </div>
        ) : null}
        <div className="sponsored-catch__info">
          <span className="sponsored-catch__text">{text}</span>
          <span className="sponsored-catch__weight">{weight}</span>
        </div>
      </div>
    ) : null}
  </>
);

export default AnimatedSponsor;
